import { ChannelTermPowerBIFrame } from '@app/models/channel-term-power-bi-frame';

export enum PowerBIFrameType {
  Report = 0,
  Dashboard = 1,
  Tile = 2
}

export class PowerBIFrame {
  public Id: number;
  public Title: string;
  public Type: PowerBIFrameType;
  public EmbedUrl: string;
  public EmbedId: string;
  public DashboardId?: string;
  public Order?: number;
  public Active: boolean;
  public BookmarkId: string;
  public ShowTitle: boolean;
  public ShowFilterPane: boolean;
  public ShowNavigationPane: boolean;
  public RouteId: string;
  public ChannelTermPowerBIFrames: Array<ChannelTermPowerBIFrame>;
  public MobileViewHeight: number;

  constructor(opt?: Partial<PowerBIFrame>) {
    Object.assign(this, opt);
  }
}
